export default {
  applyBtn: "APPLY",
  clearBtn: "CLEAR",
  closeDrawerIconAlt: "close-icon",
  filterBy: "FILTER BY",
  placeholders: {
    athleticYears: "CLASS",
    exitColleges: "TRANSFER COLLEGE",
    originColleges: "ORIGIN COLLEGE",
    positions: "ALL POSITIONS"
  },
  settingsIconAlt: "settings-icon"
};
